module.exports = __webpack_public_path__ + "static/logo4-a3a56b5ccb88c501cf7a6988d05f34fb.png";